import _get from 'lodash/get';

import { DEFAULT_FORM_DATA } from './stubs';

/**
 * @returns {import("zod").z.infer<typeof import("./stubs").FORM_SCHEMA>}
 */
export function createInitialData(carrier = null) {
  if (!carrier) return DEFAULT_FORM_DATA;

  const slas = _get(carrier, 'slas', []);

  const slasMap = slas.reduce((acc, sla) => {
    const id = _get(sla, 'id', '');
    const isActive = _get(sla, 'is_active', false);
    if (isActive) acc[id] = isActive;
    return acc;
  }, {});

  return {
    slas: slasMap
  };
}

export function createPayload(data = {}, carrier = {}) {
  const slas = _get(data, 'slas', {});

  return {
    slas_ids: Object.keys(slas)
  };
}
